// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"986e0e5f","292":"cdbca750","671":"8f06bd31","810":"12c42870"}[chunkId] + ".css";
};